import { Button, Select } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import TopCard from "../../../components/common/TopCard";
import Loader from "../../../components/ui/Loader";
import { useGetEmployeeTrackingDateListQuery } from "../../../features/employeeTracking/employeeTrackingApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import usePrint from "../../../hooks/usePrint";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatDate } from "../../../lib/time";
import { backLink, selectSearchOption } from "../../../utils/utils";
import NotFound from "../../NotFound";
import DownloadTrackingModal from "./DownloadTrackingModal";
import EmployeeMapAndDetails from "./EmployeeMapAndDetails";
import ReportRequestModal from "../../../components/Report/ReportRequestModal";
import { useTrackingDetailsReportMutation } from "../../../features/report/reportApi";

export default function EmployeeTrackingDetails() {
  const { viewId } = useParams();
  const location = useLocation();
  const [date, setDate] = useState<string | undefined>(undefined);
  const { open, handleClose, handleOpen } = useModal<
    string,
    "REPORT_REQUEST"
  >();
  const {
    downloadPDF,
    // loading: printLoading,
  } = usePrint("EmployeeTracking.pdf");

  const {
    isLoading: isDateLoading,
    isError: isDateError,
    error: dateError,
    data: dateDataList,
  } = useGetEmployeeTrackingDateListQuery(viewId || "", {
    skip: !viewId,
  });
  const [
    trackingDetailsReport,
    {
      isLoading: isGenerateLoading,
      isError: isGenerateError,
      error: generateError,
      isSuccess: isGenerateSuccess,
    },
  ] = useTrackingDetailsReportMutation();
  useError(isGenerateError, generateError, "Generate request report fail");
  useError(isDateError, dateError, "Get date fail");

  useEffect(() => {
    if (dateDataList?.data?.length) {
      setDate(dateDataList?.data?.[0]?.date);
    }
  }, [dateDataList?.data]);

  if (dateError && "status" in dateError && dateError.status === 404) {
    return <NotFound title="Sorry, data not found" />;
  }

  return (
    <SidebarLayout title="Live Tracking" appTitle="Tracking Details">
      <div className="sticky top-20 inset-x-0 z-50 ">
        <TopCard
          leftChildren={
            <>
              <Link to={backLink(location.pathname, 2)}>
                <Button
                  className="normal-dark-button"
                  icon={<BackButtonIcon />}
                >
                  Back
                </Button>
              </Link>
              <h4 className="text-header text-xl font-semibold leading-loose">
                Tracking Details
              </h4>
            </>
          }
        >
          <Select
            showSearch
            placeholder={isDateLoading ? "Loading..." : "Date"}
            value={date}
            options={dateDataList?.data?.map((el) => ({
              label: formatDate(el?.date),
              value: el?.date,
            }))}
            onChange={(val) => {
              setDate(val);
            }}
            filterOption={selectSearchOption}
            className="min-w-[125px]"
            suffixIcon={<SelectDownIcon />}
            rootClassName="icon-gray"
            loading={isDateLoading}
            disabled={isDateLoading}
          />
          {/* <Button
            className="download-button"
            icon={<DownloadIcon />}
            onClick={() => {
              handleOpen({ type: "VIEW" });
            }}
          >
            Export Report
          </Button> */}

          <Button
            onClick={() => handleOpen({ type: "REPORT_REQUEST" })}
            className="download-button"
            icon={<DownloadIcon />}
          >
            Report Requests
          </Button>

          {open.type === "VIEW" && (
            <DownloadTrackingModal
              open={open.open}
              handleClose={handleClose}
              downloadPDF={downloadPDF}
              loading={false}
            />
          )}
        </TopCard>
      </div>

      {isDateLoading ? <Loader /> : <EmployeeMapAndDetails date={date} />}

      {open.type === "REPORT_REQUEST" && (
        <ReportRequestModal
          open={open.open}
          handleClose={handleClose}
          isLoading={isGenerateLoading}
          isSuccess={isGenerateSuccess}
          handleSubmit={(params: any) => {
            trackingDetailsReport({
              body: {
                name: "Tracking report",
              },
              params: {
                ...params,
                business_member_id: viewId,
              },
            });
          }}
        />
      )}
    </SidebarLayout>
  );
}
